import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const CMS_TOKEN_KEY = 'sm_cms_token';

// Safari Private Mode / disabled storage degrades gracefully — log in dev
// so blocked writes are visible to engineers without spamming production logs.
const safeGet = (k) => {
  try { return localStorage.getItem(k); }
  catch (err) {
    if (process.env.NODE_ENV !== 'production') console.debug('[cmsApi] localStorage read blocked:', k, err?.message);
    return null;
  }
};
const safeSet = (k, v) => {
  try { localStorage.setItem(k, v); }
  catch (err) {
    if (process.env.NODE_ENV !== 'production') console.debug('[cmsApi] localStorage write blocked:', k, err?.message);
  }
};
const safeRemove = (k) => {
  try { localStorage.removeItem(k); }
  catch (err) {
    if (process.env.NODE_ENV !== 'production') console.debug('[cmsApi] localStorage remove blocked:', k, err?.message);
  }
};

export const cmsTokenStore = {
  get: () => safeGet(CMS_TOKEN_KEY),
  set: (t) => safeSet(CMS_TOKEN_KEY, t),
  clear: () => safeRemove(CMS_TOKEN_KEY),
};

const cmsApi = axios.create({
  baseURL: `${API_URL}/api/cms`,
  withCredentials: true,
});

cmsApi.interceptors.request.use((config) => {
  const token = cmsTokenStore.get();
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

cmsApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      if (window.location.pathname.startsWith('/cms') && window.location.pathname !== '/cms/login') {
        cmsTokenStore.clear();
        window.location.href = '/cms/login';
      }
    }
    return Promise.reject(err);
  }
);

export default cmsApi;
